import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class UserinformationService {
  url = this.ConfigService.getAPIBaseUrl() + 'api/UserInformation'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  getUsersList(id) {
    return this.http.get(this.url + '/GetUsersList?id=' + id)
  }
  InsertUser(data) {
    return this.http.post(this.url + '/InsertUserInfo', data)
  }
  getUserbyid(id) {
    return this.http.get(this.url +'/GetUserById?id='+id)
  }
  DeleteUser(id) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.url + '/DeleteUser?id=' + id, httpOptions)
  }
}
